export default __webpack_public_path__ + "img/2c782bda946253f15507cab29b5b9270.png";